// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ig-chat-layout {
    display: flex;
    height: calc(100vh - 64px);
    background: #f3f7f8;
    overflow: hidden;
}

/* LEFT */
.ig-sidebar {
    width: 340px;
    min-width: 340px;
    background: rgba(255, 255, 255, .92);
    backdrop-filter: blur(18px);
    border-right: 1px solid rgba(255, 255, 255, .35);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.ig-sidebar,
.ig-chat-panel {
    height: 100%;
}

.ig-sidebar-header {
    padding: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, .06);
}

.ig-sidebar-header h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: var(--primary-100);
    margin-bottom: 10px;
    /* margin: 0 0 18px;
    font-size: 28px;
    font-weight: 800;
    color: #111; */
}

.ig-search {
    height: 50px;
    border-radius: 18px;
    background: #f5f7fb;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 16px;
}

.ig-search svg {
    color: #777;
    font-size: 14px;
}

.ig-search input {
    flex: 1 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 16px;
}

.ig-conversations {
    flex: 1 1;
    overflow-y: auto;
    padding: 12px;
}

/* conversation */
.conv-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px;
    border-radius: 22px;
    cursor: pointer;
    transition: .25s;
    margin-bottom: 8px;
    position: relative;
}

.conv-item:hover {
    background: rgba(255, 255, 255, .8);
    transform: translateY(-2px);
}

.conv-item.active {
    background: white;
    box-shadow:
        0 10px 30px rgba(0, 0, 0, .08);
}

.avatar {
    /* width: 58px; */
    /* height: 58px; */
    min-width: 58px;
    border-radius: 50%;
    overflow: hidden;
    background: var(--primary-200);
    /* background: linear-gradient(135deg,
            var(--primary-100),
            var(--primary-200)); */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 22px;
}

.avatar.small {
    width: 42px;
    height: 42px;
    min-width: 42px;
    font-size: 16px;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.conv-info {
    flex: 1 1;
    min-width: 0;
}

.conv-info strong {
    display: block;
    font-size: 15px;
    color: #111;
    margin-bottom: 4px;
}

.last-message {
    display: block;
    font-size: 13px;
    color: #777;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.unread-badge {
    min-width: 24px;
    height: 24px;
    border-radius: 50px;
    background: var(--primary-200);
    color: white;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
}

/* RIGHT */
.ig-chat-panel {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    background: white;
    position: relative;
}

/* header */
.chat-header {
    position: sticky;
    top: 0;
    height: 82px;
    padding: 0 26px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    gap: 14px;
    background: rgba(255, 255, 255, .92);
    backdrop-filter: blur(10px);
    z-index: 10;
}

.chat-header h3 {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: #111;
}

.mobile-back {
    display: none;
    cursor: pointer;
    font-size: 18px;
}

/* messages */
.messages {
    flex: 1 1;
    overflow-y: auto;
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: #f6f9fa;
}

.message {
    max-width: 70%;
    padding: 14px 18px;
    border-radius: 22px;
    position: relative;
    line-height: 1.45;
    font-size: 14px;
    word-break: break-word;
    animation: fadeUp .25s ease;
}

.message.me {
    align-self: flex-end;
    color: white;
    background: var(--primary-200);
    /* background: linear-gradient(135deg,
            var(--primary-100),
            var(--primary-200)); */
    border-bottom-right-radius: 6px;
}

.message.them {
    align-self: flex-start;
    color: #111;
    background: #f3f5f8;
    border-bottom-left-radius: 6px;
}

.message-status {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    opacity: .8;
    float: right;
    margin-left: 6px;
}

.message-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    margin-top: 4px;
}

.message-time {
    font-size: 11px;
    opacity: .7;
}

/* typing */
.typing-indicator {
    width: fit-content;
    padding: 12px 18px;
    border-radius: 18px;
    background: #f3f5f8;
    color: #666;
    font-size: 13px;
}

/* input */
.chat-input {
    position: sticky;
    bottom: 0;
    padding: 20px;
    border-top: 1px solid #eee;
    display: flex;
    align-items: flex-end;
    gap: 14px;
    background: white;
    z-index: 10;
}

.chat-textarea {
    flex: 1 1;
    border: none;
    outline: none;
    resize: none;
    max-height: 140px;
    padding: 16px 20px;
    border-radius: 24px;
    background: #f5f7fb;
    font-size: 16px;
    font-family: inherit;
}

.chat-input button {
    width: 54px;
    height: 54px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: white;
    font-size: 18px;
    /* background: linear-gradient(135deg,
            var(--primary-100),
            var(--primary-200)); */
    background: var(--primary-200);
    box-shadow:
        0 12px 24px rgba(0, 0, 0, .12);
}

/* empty */
.empty-chat-panel,
.empty-conversations {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 40px;
    color: #666;
}

.empty-icon {
    font-size: 60px;
    margin-bottom: 18px;
}

.empty-chat-panel h2,
.empty-conversations h3 {
    margin: 0 0 10px;
    color: #111;
}

/* skeleton */
.skeleton {
    animation: pulse 1.3s infinite;
    background: #e5edf1;
}

.name {
    width: 120px;
    height: 15px;
    border-radius: 8px;
    margin-bottom: 8px;
}

.message.skeleton,
.conv-info .message {
    width: 170px;
    height: 12px;
    border-radius: 8px;
}

@keyframes pulse {
    0% {
        background-position: 200% 0
    }

    100% {
        background-position: -200% 0
    }
}

@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: none;
    }
}

/* MOBILE */
@media (max-width: 900px) {

    .ig-chat-layout {
        position: relative;
        overflow: hidden;
        height: calc(100vh - 64px - 60px);
    }

    /* conversations visibles */
    .ig-sidebar {
        width: 100%;
        min-width: 100%;
        height: 100%;
        flex-shrink: 0;
    }

    /* chat caché par défaut */
    .ig-chat-panel {
        display: none;
        width: 100%;
        height: 100%;
        background: white;
    }

    /* quand conversation ouverte */
    .chat-open .ig-sidebar {
        display: none;
    }

    .chat-open .ig-chat-panel {
        display: flex;
        flex-direction: column;
    }

    /* desktop empty hidden mobile */
    .empty-chat-panel {
        display: none;
    }

    .mobile-back {
        display: block;
    }

    .messages {
        padding: 18px;
    }

    .message {
        max-width: 85%;
    }
}


.message-skeleton {
    height: 48px;
    border-radius: 22px;
    animation: pulse 1.2s infinite;
    background: #e5edf1;
}

.message-skeleton.me {
    width: 220px;
    align-self: flex-end;
}

.message-skeleton.them {
    width: 180px;
    align-self: flex-start;
}

.message:has(.shared-post-card) {
    padding: 10px;
    max-width: fit-content;
}


@media (max-width: 768px) {

    .ig-chat-layout.chat-open {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: white;
        height: 100vh;
        width: 100vw;
    }

    .ig-chat-layout.chat-open .ig-chat-panel {
        width: 100%;
        height: 100dvh;
        display: flex;
        flex-direction: column;
    }

    .ig-chat-layout.chat-open .messages {
        flex: 1 1;
        overflow-y: auto;
    }

    .ig-chat-layout.chat-open .ig-sidebar {
        display: none;
    }
}


.conversation-actions {
    position: relative;
    margin-left: auto;
    /* color: var(--primary-200); */
    padding: 8px;
}


.conversation-menu-btn:hover {
    opacity: 1;
}

.conversation-menu {
    position: absolute;
    right: 0;
    top: 30px;
    background: var(--primary-100);
    border: none;
    border-radius: 8px;
    overflow: hidden;
    z-index: 999;
    transition: 0.3s;
}

.conversation-menu button {
    background: transparent;
    border: none;
    color: white;
    padding: 10px 14px;
    cursor: pointer;
    width: 100%;
    text-align: left;
    display: flex;
    gap: 8px;
    align-items: center;
    transition: 0.2s;
}

.conversation-menu button:hover {
    background: #e87000;
}

.edited-label {
    font-size: 11px;
    opacity: .7;
    margin-top: 4px;
}









.edit-message-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.65);

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 9999;

    backdrop-filter: blur(4px);
}

.edit-message-modal {
    width: 100%;
    max-width: 520px;

    background: #ffffff;
    color: #111827;

    border-radius: 16px;

    padding: 24px;

    box-shadow:
        0 20px 60px rgba(0, 0, 0, 0.18);

    animation: modalFadeIn 0.2s ease;
}

.edit-message-modal h3 {
    margin: 0 0 18px;

    font-size: 1.15rem;
    font-weight: 700;

    color: #111827;
}

.edit-message-modal textarea {
    width: 100%;
    min-height: 130px;

    resize: vertical;

    border: 1px solid #d1d5db;
    border-radius: 12px;

    padding: 14px;

    font-size: 0.95rem;
    line-height: 1.5;

    outline: none;

    transition: all 0.2s ease;
}

.edit-message-modal textarea:focus {
    border-color: var(--primary-200);

    box-shadow:
        0 0 0 4px rgba(37, 99, 235, 0.12);
}

.edit-message-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    margin-top: 20px;
}

.cancel-btn {
    border: 1px solid #d1d5db;

    background: #ffffff;
    color: #374151;

    padding: 10px 18px;

    border-radius: 10px;

    cursor: pointer;

    font-weight: 600;

    transition: all 0.2s ease;
}

.cancel-btn:hover {
    background: #f9fafb;
}

.save-btn {
    border: none;

    background: var(--primary-200);
    color: white;

    padding: 10px 18px;

    border-radius: 10px;

    cursor: pointer;

    font-weight: 600;

    transition: all 0.2s ease;
}

.save-btn:hover:not(:disabled) {
    background: var(--primary-200);
}

.save-btn:disabled {
    background: #93c5fd;

    cursor: not-allowed;
}

@keyframes modalFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* .edit-message-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.edit-message-modal {
    width: 420px;
    max-width: 90%;
    background: #efefef;
    border-radius: 16px;
    padding: 20px;
}

.edit-message-modal textarea {
    width: 100%;
    min-height: 120px;
    margin-top: 12px;
}

.edit-message-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 16px;
} */

/* .save-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
} */

.deleted-message {
    font-style: italic;
    opacity: .7;
}

.date-separator {
    text-align: center;
    margin: 20px 0;
    font-size: 12px;
    color: #94a3b8;
    font-weight: 600;
}

/* CarrerUp messaging control room: visual layer only, no behaviour changes. */
.ig-chat-layout {
    width: min(1360px, calc(100% - 48px));
    height: calc(100dvh - 40px);
    min-height: 0;
    margin: 20px auto;
    overflow: hidden;
    border: 1px solid rgba(78, 119, 153, .18);
    border-radius: 22px;
    background: #f3f7f8;
    box-shadow: 0 22px 52px rgba(30, 63, 88, .12), inset 0 1px #ffffff;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* Dashboard provides the navigation offset; keep its page exactly viewport-high. */
main:has(.ig-chat-layout) {
    box-sizing: border-box;
    height: 100dvh;
    min-height: 100dvh !important;
    overflow: hidden;
}

main .ig-chat-layout { height: calc(100dvh - 104px); }

.ig-sidebar {
    width: 356px;
    min-width: 356px;
    border-right: 1px solid rgba(78, 119, 153, .16);
    background: #fbfcfd;
}

.ig-sidebar-header {
    position: relative;
    padding: 25px 26px;
    border-bottom: 1px solid rgba(78, 119, 153, .14);
}

.ig-sidebar-header::before {
    content: "";
    position: absolute;
    top: 0;
    right: 24px;
    left: 24px;
    height: 3px;
    border-radius: 0 0 4px 4px;
    background: #e95a13;
}

.ig-sidebar-header h2 {
    margin: 0 0 16px;
    color: #1d394f;
    font-size: 1.12rem;
    font-weight: 850;
    letter-spacing: -.02em;
}

.ig-search {
    height: 44px;
    gap: 10px;
    padding: 0 13px;
    border: 1px solid rgba(78, 119, 153, .16);
    border-radius: 12px;
    background: #f1f5f7;
    transition: .18s ease;
}

.ig-search:focus-within {
    border-color: #e95a13;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.ig-search svg { color: #4e7799; font-size: .8rem; }
.ig-search input { color: #29475e; font-family: inherit; font-size: .8rem; font-weight: 600; }
.ig-search input::placeholder { color: #71899b; }

.ig-conversations { padding: 10px; scrollbar-width: thin; scrollbar-color: #94a9ba transparent; }

.conv-item {
    gap: 11px;
    min-height: 58px;
    margin-bottom: 5px;
    padding: 10px;
    border: 1px solid transparent;
    border-radius: 14px;
}

.conv-item:hover {
    border-color: rgba(233, 90, 19, .2);
    background: #fff8f4;
    transform: translateX(2px);
}

.conv-item.active {
    border-color: rgba(233, 90, 19, .2);
    background: #fff3ec;
    box-shadow: inset 3px 0 #e95a13, 0 8px 18px rgba(30, 63, 88, .06);
}

.avatar {
    width: 46px;
    height: 46px;
    min-width: 46px;
    border: 2px solid #ffffff;
    border-radius: 14px;
    color: #ffffff;
    background: #4e7799;
    box-shadow: 0 5px 12px rgba(78, 119, 153, .18);
    font-size: 1rem;
}

.avatar img { border-radius: 11px; }
.avatar.small { width: 38px; height: 38px; min-width: 38px; border-radius: 11px; font-size: .85rem; }
.conv-info strong { margin-bottom: 4px; color: #29475e; font-family: inherit; font-size: .83rem; font-weight: 800; }
.last-message { color: #71899b; font-size: .73rem; font-weight: 550; }

.unread-badge {
    min-width: 19px;
    height: 19px;
    padding: 0 5px;
    border: 2px solid #ffffff;
    background: #e95a13;
    box-shadow: 0 3px 8px rgba(233, 90, 19, .22);
    font-size: .62rem;
}

.conversation-actions { padding: 6px; color: #71899b; transition: .18s ease; }
.conversation-actions:hover { color: #e95a13; }
.conversation-menu-btn { cursor: pointer; }
.conversation-menu {
    top: 32px;
    min-width: 128px;
    padding: 5px;
    border: 1px solid rgba(78, 119, 153, .16);
    border-radius: 11px;
    background: #fbfcfd;
    box-shadow: 0 13px 28px rgba(30, 63, 88, .16);
}
.conversation-menu button { border-radius: 7px; color: #b63e0a; font-family: inherit; font-size: .73rem; font-weight: 750; }
.conversation-menu button:hover { background: #fff3ec; }

.ig-chat-panel { background: #f6f9fa; }

.chat-header {
    height: 74px;
    padding: 0 22px;
    border-bottom: 1px solid rgba(78, 119, 153, .15);
    background: #fbfcfd;
    box-shadow: 0 5px 16px rgba(30, 63, 88, .04);
}

.chat-header h3 { color: #1d394f; font-family: inherit; font-size: .95rem; font-weight: 850; letter-spacing: -.01em; }
.chat-header h3::after { content: ""; display: inline-block; width: 6px; height: 6px; margin: 0 0 1px 7px; border-radius: 50%; background: #22a65a; box-shadow: 0 0 0 3px rgba(34, 166, 90, .12); }
.mobile-back { color: #4e7799; }

.messages {
    padding: 26px clamp(18px, 4vw, 48px);
    gap: 9px;
    background: #f6f9fa;
    scrollbar-width: thin;
    scrollbar-color: #94a9ba transparent;
}

.message {
    max-width: min(70%, 580px);
    padding: 11px 14px;
    border: 1px solid rgba(78, 119, 153, .12);
    border-radius: 15px;
    box-shadow: 0 5px 12px rgba(30, 63, 88, .05);
    font-family: inherit;
    font-size: .82rem;
    font-weight: 550;
}

.message.me { border-color: #e95a13; background: #e95a13; box-shadow: 0 8px 16px rgba(233, 90, 19, .18); border-bottom-right-radius: 4px; }
.message.them { color: #29475e; background: #ffffff; border-bottom-left-radius: 4px; }
.message-footer { margin-top: 5px; }
.message-time, .edited-label { font-size: .63rem; font-weight: 650; }
.typing-indicator { padding: 9px 12px; border: 1px solid rgba(78, 119, 153, .13); border-radius: 11px; color: #4e7799; background: #ffffff; font-family: inherit; font-size: .72rem; font-weight: 700; }
.date-separator { width: fit-content; margin: 14px auto; padding: 5px 9px; border: 1px solid rgba(78, 119, 153, .14); border-radius: 999px; color: #71899b; background: #eef3f5; font-family: inherit; font-size: .62rem; letter-spacing: .04em; text-transform: uppercase; }

.chat-input {
    padding: 14px 18px;
    border-top: 1px solid rgba(78, 119, 153, .15);
    background: #fbfcfd;
}

.chat-textarea {
    min-height: 44px;
    padding: 12px 14px;
    border: 1px solid rgba(78, 119, 153, .18);
    border-radius: 12px;
    color: #29475e;
    background: #f1f5f7;
    font-family: inherit;
    font-size: .82rem;
    font-weight: 550;
    transition: .18s ease;
}

.chat-textarea:focus { border-color: #e95a13; background: #ffffff; box-shadow: 0 0 0 4px rgba(233, 90, 19, .1); }
.chat-input button { width: 44px; height: 44px; border-radius: 12px; background: #e95a13; box-shadow: 0 7px 15px rgba(233, 90, 19, .2); font-size: .9rem; transition: .18s ease; }
.chat-input button:hover { background: #d84f0d; transform: translateY(-1px); }

.empty-chat-panel, .empty-conversations { color: #71899b; font-family: inherit; }
.empty-chat-panel .empty-icon, .empty-conversations .empty-icon { display: grid; width: 62px; height: 62px; place-items: center; margin-bottom: 14px; border: 1px solid rgba(233, 90, 19, .2); border-radius: 18px; background: #fff3ec; font-size: 1.75rem; }
.empty-chat-panel h2, .empty-conversations h3 { color: #29475e; font-family: inherit; font-size: 1rem; font-weight: 850; }
.empty-chat-panel p, .empty-conversations p { max-width: 290px; margin: 0; font-size: .8rem; font-weight: 550; line-height: 1.55; }

.ig-chat-layout .skeleton, .ig-chat-layout .message-skeleton { background: #e5edf1; animation: conversation-pulse 1.15s ease-in-out infinite alternate; }
@keyframes conversation-pulse { from { opacity: .55; } to { opacity: 1; } }
.message-skeleton { border-radius: 14px; }

.ig-chat-layout button:focus-visible, .ig-chat-layout input:focus-visible, .ig-chat-layout textarea:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }

/* Conversation hand-off: selection signal followed by a panel reveal. */
.conv-item.active { animation: conversation-selected .34s cubic-bezier(.2, .8, .2, 1); }

.chat-open .ig-chat-panel { animation: chat-panel-reveal .42s cubic-bezier(.2, .8, .2, 1) both; }

.chat-open .ig-chat-panel::before {
    content: "";
    position: absolute;
    z-index: 20;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    transform-origin: top;
    background: #e95a13;
    pointer-events: none;
    animation: chat-signal .52s cubic-bezier(.2, .8, .2, 1) both;
}

.chat-open .chat-header { animation: chat-header-in .38s .08s ease both; }
.chat-open .messages { animation: chat-content-in .4s .15s ease both; }

@keyframes conversation-selected {
    0% { transform: translateX(-8px); opacity: .45; }
    65% { transform: translateX(2px); }
    100% { transform: translateX(0); opacity: 1; }
}

@keyframes chat-panel-reveal {
    from { opacity: 0; transform: translateX(34px) scale(.985); }
    to { opacity: 1; transform: translateX(0) scale(1); }
}

@keyframes chat-signal {
    0% { transform: scaleY(0); opacity: 0; }
    35% { transform: scaleY(1); opacity: 1; }
    100% { transform: scaleY(1); opacity: 0; }
}

@keyframes chat-header-in {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes chat-content-in {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
    .conv-item.active,
    .chat-open .ig-chat-panel,
    .chat-open .ig-chat-panel::before,
    .chat-open .chat-header,
    .chat-open .messages { animation: none; }
}

@media (max-width: 900px) {
    main:has(.ig-chat-layout) { width: 100%; max-width: 100%; overflow-x: clip; background: #f6f9fa !important; }
    .ig-chat-layout { box-sizing: border-box; width: 100%; max-width: 100%; height: 100dvh; min-height: 0; margin: 0; border: 0; border-radius: 0; background: #f6f9fa; box-shadow: none; }
    main .ig-chat-layout { height: calc(100dvh - 124px); }
    .ig-sidebar { width: 100%; min-width: 100%; border: 0; background: #f6f9fa; }
    .ig-sidebar-header {  background: #fbfcfd; box-shadow: 0 5px 14px rgba(30, 63, 88, .05); margin-top: 22px; border-radius: 0 0 17px 17px;  }
    .ig-sidebar-header::before { right: 16px; left: 16px; }
    .ig-sidebar-header h2 { margin-bottom: 14px; font-size: 1.04rem; }
    .ig-conversations { padding: 13px 12px 20px; background: #f6f9fa; overscroll-behavior: contain; }
    .conv-item { min-height: 66px; margin-bottom: 9px; padding: 10px 11px; border-color: rgba(78, 119, 153, .14); border-radius: 16px; background: #ffffff; box-shadow: 0 7px 15px rgba(30, 63, 88, .05); }
    .conv-item:hover { transform: none; }
    .conv-item.active { background: #fff8f4; box-shadow: inset 3px 0 #e95a13, 0 8px 18px rgba(30, 63, 88, .07); }
    .avatar { width: 48px; height: 48px; min-width: 48px; }
    .conversation-actions { padding: 8px; }
}

@media (max-width: 768px) {
    .ig-chat-layout.chat-open { background: #f6f9fa; }
    .chat-header { height: 68px; padding: 0 14px; gap: 10px; }
    .mobile-back { display: grid; padding: 10px; width: 20px; height: 20px; place-items: center; border: 1px solid rgba(78, 119, 153, .16); border-radius: 10px; background: #ffffff; font-size: .85rem; }
    .messages { padding: 18px 13px; }
    .message { max-width: 84%; padding: 10px 12px; font-size: .79rem; }
    .chat-input { gap: 9px; padding: 10px 12px calc(10px + env(safe-area-inset-bottom)); }
    .chat-input button { width: 42px; height: 42px; flex: 0 0 42px; }
    .chat-textarea { min-height: 42px; padding: 11px 12px; }
}

/* .date-separator {
    width: fit-content;
    margin: 15px auto;
    background: rgba(255,255,255,.08);
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 12px;
} */
`, "",{"version":3,"sources":["webpack://./src/componentsL/Conversations.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,2BAA2B;IAC3B,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB;;;kBAGc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB;sCACkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B;;kCAE8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oCAAoC;IACpC,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA,aAAa;AACb;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;IAC9B;;kCAE8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf;;kCAE8B;IAC9B,8BAA8B;IAC9B;sCACkC;AACtC;;AAEA,UAAU;AACV;;IAEI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;AACf;;AAEA,aAAa;AACb;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA,WAAW;AACX;;IAEI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA,2BAA2B;IAC3B;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,cAAc;IAClB;;IAEA,0BAA0B;IAC1B;QACI,aAAa;QACb,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA,+BAA+B;IAC/B;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA,gCAAgC;IAChC;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;;IAEI;QACI,eAAe;QACf,QAAQ;QACR,aAAa;QACb,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;AAChB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;;;;;;;;;AAUA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;;IAE/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,aAAa;;IAEb,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;;IAEhB,mBAAmB;IACnB,cAAc;;IAEd,mBAAmB;;IAEnB,aAAa;;IAEb;uCACmC;;IAEnC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;;IAEhB,kBAAkB;IAClB,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;;IAEjB,gBAAgB;;IAEhB,yBAAyB;IACzB,mBAAmB;;IAEnB,aAAa;;IAEb,kBAAkB;IAClB,gBAAgB;;IAEhB,aAAa;;IAEb,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;;IAEhC;yCACqC;AACzC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;;IAET,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;;IAEzB,mBAAmB;IACnB,cAAc;;IAEd,kBAAkB;;IAElB,mBAAmB;;IAEnB,eAAe;;IAEf,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;;IAEZ,8BAA8B;IAC9B,YAAY;;IAEZ,kBAAkB;;IAElB,mBAAmB;;IAEnB,eAAe;;IAEf,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH;;;GAGG;;AAEH;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,8EAA8E;AAC9E;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,kEAAkE;IAClE,oEAAoE;AACxE;;AAEA,mFAAmF;AACnF;IACI,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,uBAAuB,4BAA4B,EAAE;;AAErD;IACI,YAAY;IACZ,gBAAgB;IAChB,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,mBAAmB,cAAc,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC7F,gCAAgC,cAAc,EAAE;;AAEhD,oBAAoB,aAAa,EAAE,qBAAqB,EAAE,oCAAoC,EAAE;;AAEhG;IACI,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,iEAAiE;AACrE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,8CAA8C;IAC9C,eAAe;AACnB;;AAEA,cAAc,mBAAmB,EAAE;AACnC,gBAAgB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACpG,oBAAoB,kBAAkB,EAAE,cAAc,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACnH,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAErE;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA,wBAAwB,YAAY,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC7E,8BAA8B,cAAc,EAAE;AAC9C,yBAAyB,eAAe,EAAE;AAC1C;IACI,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;AACjD;AACA,4BAA4B,kBAAkB,EAAE,cAAc,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC3H,kCAAkC,mBAAmB,EAAE;;AAEvD,iBAAiB,mBAAmB,EAAE;;AAEtC;IACI,YAAY;IACZ,eAAe;IACf,gDAAgD;IAChD,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,kBAAkB,cAAc,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACrH,yBAAyB,WAAW,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE;AAClM,eAAe,cAAc,EAAE;;AAE/B;IACI,oCAAoC;IACpC,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,4CAA4C;IAC5C,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,cAAc,qBAAqB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE,+BAA+B,EAAE;AAC1I,gBAAgB,cAAc,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AACrF,kBAAkB,eAAe,EAAE;AACnC,+BAA+B,iBAAiB,EAAE,gBAAgB,EAAE;AACpE,oBAAoB,iBAAiB,EAAE,yCAAyC,EAAE,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvM,kBAAkB,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,yCAAyC,EAAE,oBAAoB,EAAE,cAAc,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;;AAE5Q;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,uBAAuB,qBAAqB,EAAE,mBAAmB,EAAE,2CAA2C,EAAE;AAChH,qBAAqB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACjL,2BAA2B,mBAAmB,EAAE,2BAA2B,EAAE;;AAE7E,0CAA0C,cAAc,EAAE,oBAAoB,EAAE;AAChF,kEAAkE,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,uCAAuC,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC7P,gDAAgD,cAAc,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACzH,8CAA8C,gBAAgB,EAAE,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAElI,+DAA+D,mBAAmB,EAAE,kEAAkE,EAAE;AACxJ,gCAAgC,OAAO,YAAY,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC1E,oBAAoB,mBAAmB,EAAE;;AAEzC,oHAAoH,0BAA0B,EAAE,mBAAmB,EAAE;;AAErK,wEAAwE;AACxE,oBAAoB,iEAAiE,EAAE;;AAEvF,4BAA4B,kEAAkE,EAAE;;AAEhG;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,4DAA4D;AAChE;;AAEA,0BAA0B,6CAA6C,EAAE;AACzE,uBAAuB,6CAA6C,EAAE;;AAEtE;IACI,KAAK,2BAA2B,EAAE,YAAY,EAAE;IAChD,MAAM,0BAA0B,EAAE;IAClC,OAAO,wBAAwB,EAAE,UAAU,EAAE;AACjD;;AAEA;IACI,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;IACI,KAAK,oBAAoB,EAAE,UAAU,EAAE;IACvC,MAAM,oBAAoB,EAAE,UAAU,EAAE;IACxC,OAAO,oBAAoB,EAAE,UAAU,EAAE;AAC7C;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI;;;;2BAIuB,eAAe,EAAE;AAC5C;;AAEA;IACI,4BAA4B,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,8BAA8B,EAAE;IAC5G,kBAAkB,sBAAsB,EAAE,WAAW,EAAE,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,SAAS,EAAE,SAAS,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;IACtL,uBAAuB,4BAA4B,EAAE;IACrD,cAAc,WAAW,EAAE,eAAe,EAAE,SAAS,EAAE,mBAAmB,EAAE;IAC5E,sBAAsB,mBAAmB,EAAE,4CAA4C,EAAE,gBAAgB,EAAE,4BAA4B,GAAG;IAC1I,6BAA6B,WAAW,EAAE,UAAU,EAAE;IACtD,wBAAwB,mBAAmB,EAAE,kBAAkB,EAAE;IACjE,oBAAoB,uBAAuB,EAAE,mBAAmB,EAAE,4BAA4B,EAAE;IAChG,aAAa,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE;IACtM,mBAAmB,eAAe,EAAE;IACpC,oBAAoB,mBAAmB,EAAE,iEAAiE,EAAE;IAC5G,UAAU,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;IACtD,wBAAwB,YAAY,EAAE;AAC1C;;AAEA;IACI,4BAA4B,mBAAmB,EAAE;IACjD,eAAe,YAAY,EAAE,eAAe,EAAE,SAAS,EAAE;IACzD,eAAe,aAAa,EAAE,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,yCAAyC,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;IACrM,YAAY,kBAAkB,EAAE;IAChC,WAAW,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;IAClE,cAAc,QAAQ,EAAE,2DAA2D,EAAE;IACrF,qBAAqB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;IAChE,iBAAiB,gBAAgB,EAAE,kBAAkB,EAAE;AAC3D;;AAEA;;;;;;;GAOG","sourcesContent":[".ig-chat-layout {\n    display: flex;\n    height: calc(100vh - 64px);\n    background: #f3f7f8;\n    overflow: hidden;\n}\n\n/* LEFT */\n.ig-sidebar {\n    width: 340px;\n    min-width: 340px;\n    background: rgba(255, 255, 255, .92);\n    backdrop-filter: blur(18px);\n    border-right: 1px solid rgba(255, 255, 255, .35);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.ig-sidebar,\n.ig-chat-panel {\n    height: 100%;\n}\n\n.ig-sidebar-header {\n    padding: 24px;\n    border-bottom: 1px solid rgba(0, 0, 0, .06);\n}\n\n.ig-sidebar-header h2 {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--primary-100);\n    margin-bottom: 10px;\n    /* margin: 0 0 18px;\n    font-size: 28px;\n    font-weight: 800;\n    color: #111; */\n}\n\n.ig-search {\n    height: 50px;\n    border-radius: 18px;\n    background: #f5f7fb;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 0 16px;\n}\n\n.ig-search svg {\n    color: #777;\n    font-size: 14px;\n}\n\n.ig-search input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 16px;\n}\n\n.ig-conversations {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px;\n}\n\n/* conversation */\n.conv-item {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 14px;\n    border-radius: 22px;\n    cursor: pointer;\n    transition: .25s;\n    margin-bottom: 8px;\n    position: relative;\n}\n\n.conv-item:hover {\n    background: rgba(255, 255, 255, .8);\n    transform: translateY(-2px);\n}\n\n.conv-item.active {\n    background: white;\n    box-shadow:\n        0 10px 30px rgba(0, 0, 0, .08);\n}\n\n.avatar {\n    /* width: 58px; */\n    /* height: 58px; */\n    min-width: 58px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: var(--primary-200);\n    /* background: linear-gradient(135deg,\n            var(--primary-100),\n            var(--primary-200)); */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 22px;\n}\n\n.avatar.small {\n    width: 42px;\n    height: 42px;\n    min-width: 42px;\n    font-size: 16px;\n}\n\n.avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.conv-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.conv-info strong {\n    display: block;\n    font-size: 15px;\n    color: #111;\n    margin-bottom: 4px;\n}\n\n.last-message {\n    display: block;\n    font-size: 13px;\n    color: #777;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.unread-badge {\n    min-width: 24px;\n    height: 24px;\n    border-radius: 50px;\n    background: var(--primary-200);\n    color: white;\n    font-size: 12px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 8px;\n}\n\n/* RIGHT */\n.ig-chat-panel {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background: white;\n    position: relative;\n}\n\n/* header */\n.chat-header {\n    position: sticky;\n    top: 0;\n    height: 82px;\n    padding: 0 26px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    background: rgba(255, 255, 255, .92);\n    backdrop-filter: blur(10px);\n    z-index: 10;\n}\n\n.chat-header h3 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 700;\n    color: #111;\n}\n\n.mobile-back {\n    display: none;\n    cursor: pointer;\n    font-size: 18px;\n}\n\n/* messages */\n.messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 30px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    background: #f6f9fa;\n}\n\n.message {\n    max-width: 70%;\n    padding: 14px 18px;\n    border-radius: 22px;\n    position: relative;\n    line-height: 1.45;\n    font-size: 14px;\n    word-break: break-word;\n    animation: fadeUp .25s ease;\n}\n\n.message.me {\n    align-self: flex-end;\n    color: white;\n    background: var(--primary-200);\n    /* background: linear-gradient(135deg,\n            var(--primary-100),\n            var(--primary-200)); */\n    border-bottom-right-radius: 6px;\n}\n\n.message.them {\n    align-self: flex-start;\n    color: #111;\n    background: #f3f5f8;\n    border-bottom-left-radius: 6px;\n}\n\n.message-status {\n    display: block;\n    margin-top: 8px;\n    font-size: 12px;\n    opacity: .8;\n    float: right;\n    margin-left: 6px;\n}\n\n.message-footer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 4px;\n    margin-top: 4px;\n}\n\n.message-time {\n    font-size: 11px;\n    opacity: .7;\n}\n\n/* typing */\n.typing-indicator {\n    width: fit-content;\n    padding: 12px 18px;\n    border-radius: 18px;\n    background: #f3f5f8;\n    color: #666;\n    font-size: 13px;\n}\n\n/* input */\n.chat-input {\n    position: sticky;\n    bottom: 0;\n    padding: 20px;\n    border-top: 1px solid #eee;\n    display: flex;\n    align-items: flex-end;\n    gap: 14px;\n    background: white;\n    z-index: 10;\n}\n\n.chat-textarea {\n    flex: 1;\n    border: none;\n    outline: none;\n    resize: none;\n    max-height: 140px;\n    padding: 16px 20px;\n    border-radius: 24px;\n    background: #f5f7fb;\n    font-size: 16px;\n    font-family: inherit;\n}\n\n.chat-input button {\n    width: 54px;\n    height: 54px;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    color: white;\n    font-size: 18px;\n    /* background: linear-gradient(135deg,\n            var(--primary-100),\n            var(--primary-200)); */\n    background: var(--primary-200);\n    box-shadow:\n        0 12px 24px rgba(0, 0, 0, .12);\n}\n\n/* empty */\n.empty-chat-panel,\n.empty-conversations {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 40px;\n    color: #666;\n}\n\n.empty-icon {\n    font-size: 60px;\n    margin-bottom: 18px;\n}\n\n.empty-chat-panel h2,\n.empty-conversations h3 {\n    margin: 0 0 10px;\n    color: #111;\n}\n\n/* skeleton */\n.skeleton {\n    animation: pulse 1.3s infinite;\n    background: #e5edf1;\n}\n\n.name {\n    width: 120px;\n    height: 15px;\n    border-radius: 8px;\n    margin-bottom: 8px;\n}\n\n.message.skeleton,\n.conv-info .message {\n    width: 170px;\n    height: 12px;\n    border-radius: 8px;\n}\n\n@keyframes pulse {\n    0% {\n        background-position: 200% 0\n    }\n\n    100% {\n        background-position: -200% 0\n    }\n}\n\n@keyframes fadeUp {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: none;\n    }\n}\n\n/* MOBILE */\n@media (max-width: 900px) {\n\n    .ig-chat-layout {\n        position: relative;\n        overflow: hidden;\n        height: calc(100vh - 64px - 60px);\n    }\n\n    /* conversations visibles */\n    .ig-sidebar {\n        width: 100%;\n        min-width: 100%;\n        height: 100%;\n        flex-shrink: 0;\n    }\n\n    /* chat caché par défaut */\n    .ig-chat-panel {\n        display: none;\n        width: 100%;\n        height: 100%;\n        background: white;\n    }\n\n    /* quand conversation ouverte */\n    .chat-open .ig-sidebar {\n        display: none;\n    }\n\n    .chat-open .ig-chat-panel {\n        display: flex;\n        flex-direction: column;\n    }\n\n    /* desktop empty hidden mobile */\n    .empty-chat-panel {\n        display: none;\n    }\n\n    .mobile-back {\n        display: block;\n    }\n\n    .messages {\n        padding: 18px;\n    }\n\n    .message {\n        max-width: 85%;\n    }\n}\n\n\n.message-skeleton {\n    height: 48px;\n    border-radius: 22px;\n    animation: pulse 1.2s infinite;\n    background: #e5edf1;\n}\n\n.message-skeleton.me {\n    width: 220px;\n    align-self: flex-end;\n}\n\n.message-skeleton.them {\n    width: 180px;\n    align-self: flex-start;\n}\n\n.message:has(.shared-post-card) {\n    padding: 10px;\n    max-width: fit-content;\n}\n\n\n@media (max-width: 768px) {\n\n    .ig-chat-layout.chat-open {\n        position: fixed;\n        inset: 0;\n        z-index: 9999;\n        background: white;\n        height: 100vh;\n        width: 100vw;\n    }\n\n    .ig-chat-layout.chat-open .ig-chat-panel {\n        width: 100%;\n        height: 100dvh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .ig-chat-layout.chat-open .messages {\n        flex: 1;\n        overflow-y: auto;\n    }\n\n    .ig-chat-layout.chat-open .ig-sidebar {\n        display: none;\n    }\n}\n\n\n.conversation-actions {\n    position: relative;\n    margin-left: auto;\n    /* color: var(--primary-200); */\n    padding: 8px;\n}\n\n\n.conversation-menu-btn:hover {\n    opacity: 1;\n}\n\n.conversation-menu {\n    position: absolute;\n    right: 0;\n    top: 30px;\n    background: var(--primary-100);\n    border: none;\n    border-radius: 8px;\n    overflow: hidden;\n    z-index: 999;\n    transition: 0.3s;\n}\n\n.conversation-menu button {\n    background: transparent;\n    border: none;\n    color: white;\n    padding: 10px 14px;\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    transition: 0.2s;\n}\n\n.conversation-menu button:hover {\n    background: #e87000;\n}\n\n.edited-label {\n    font-size: 11px;\n    opacity: .7;\n    margin-top: 4px;\n}\n\n\n\n\n\n\n\n\n\n.edit-message-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.65);\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    z-index: 9999;\n\n    backdrop-filter: blur(4px);\n}\n\n.edit-message-modal {\n    width: 100%;\n    max-width: 520px;\n\n    background: #ffffff;\n    color: #111827;\n\n    border-radius: 16px;\n\n    padding: 24px;\n\n    box-shadow:\n        0 20px 60px rgba(0, 0, 0, 0.18);\n\n    animation: modalFadeIn 0.2s ease;\n}\n\n.edit-message-modal h3 {\n    margin: 0 0 18px;\n\n    font-size: 1.15rem;\n    font-weight: 700;\n\n    color: #111827;\n}\n\n.edit-message-modal textarea {\n    width: 100%;\n    min-height: 130px;\n\n    resize: vertical;\n\n    border: 1px solid #d1d5db;\n    border-radius: 12px;\n\n    padding: 14px;\n\n    font-size: 0.95rem;\n    line-height: 1.5;\n\n    outline: none;\n\n    transition: all 0.2s ease;\n}\n\n.edit-message-modal textarea:focus {\n    border-color: var(--primary-200);\n\n    box-shadow:\n        0 0 0 4px rgba(37, 99, 235, 0.12);\n}\n\n.edit-message-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n\n    margin-top: 20px;\n}\n\n.cancel-btn {\n    border: 1px solid #d1d5db;\n\n    background: #ffffff;\n    color: #374151;\n\n    padding: 10px 18px;\n\n    border-radius: 10px;\n\n    cursor: pointer;\n\n    font-weight: 600;\n\n    transition: all 0.2s ease;\n}\n\n.cancel-btn:hover {\n    background: #f9fafb;\n}\n\n.save-btn {\n    border: none;\n\n    background: var(--primary-200);\n    color: white;\n\n    padding: 10px 18px;\n\n    border-radius: 10px;\n\n    cursor: pointer;\n\n    font-weight: 600;\n\n    transition: all 0.2s ease;\n}\n\n.save-btn:hover:not(:disabled) {\n    background: var(--primary-200);\n}\n\n.save-btn:disabled {\n    background: #93c5fd;\n\n    cursor: not-allowed;\n}\n\n@keyframes modalFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* .edit-message-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, .65);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.edit-message-modal {\n    width: 420px;\n    max-width: 90%;\n    background: #efefef;\n    border-radius: 16px;\n    padding: 20px;\n}\n\n.edit-message-modal textarea {\n    width: 100%;\n    min-height: 120px;\n    margin-top: 12px;\n}\n\n.edit-message-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 16px;\n} */\n\n/* .save-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n} */\n\n.deleted-message {\n    font-style: italic;\n    opacity: .7;\n}\n\n.date-separator {\n    text-align: center;\n    margin: 20px 0;\n    font-size: 12px;\n    color: #94a3b8;\n    font-weight: 600;\n}\n\n/* CarrerUp messaging control room: visual layer only, no behaviour changes. */\n.ig-chat-layout {\n    width: min(1360px, calc(100% - 48px));\n    height: calc(100dvh - 40px);\n    min-height: 0;\n    margin: 20px auto;\n    overflow: hidden;\n    border: 1px solid rgba(78, 119, 153, .18);\n    border-radius: 22px;\n    background: #f3f7f8;\n    box-shadow: 0 22px 52px rgba(30, 63, 88, .12), inset 0 1px #ffffff;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n/* Dashboard provides the navigation offset; keep its page exactly viewport-high. */\nmain:has(.ig-chat-layout) {\n    box-sizing: border-box;\n    height: 100dvh;\n    min-height: 100dvh !important;\n    overflow: hidden;\n}\n\nmain .ig-chat-layout { height: calc(100dvh - 104px); }\n\n.ig-sidebar {\n    width: 356px;\n    min-width: 356px;\n    border-right: 1px solid rgba(78, 119, 153, .16);\n    background: #fbfcfd;\n}\n\n.ig-sidebar-header {\n    position: relative;\n    padding: 25px 26px;\n    border-bottom: 1px solid rgba(78, 119, 153, .14);\n}\n\n.ig-sidebar-header::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 24px;\n    left: 24px;\n    height: 3px;\n    border-radius: 0 0 4px 4px;\n    background: #e95a13;\n}\n\n.ig-sidebar-header h2 {\n    margin: 0 0 16px;\n    color: #1d394f;\n    font-size: 1.12rem;\n    font-weight: 850;\n    letter-spacing: -.02em;\n}\n\n.ig-search {\n    height: 44px;\n    gap: 10px;\n    padding: 0 13px;\n    border: 1px solid rgba(78, 119, 153, .16);\n    border-radius: 12px;\n    background: #f1f5f7;\n    transition: .18s ease;\n}\n\n.ig-search:focus-within {\n    border-color: #e95a13;\n    background: #ffffff;\n    box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.ig-search svg { color: #4e7799; font-size: .8rem; }\n.ig-search input { color: #29475e; font-family: inherit; font-size: .8rem; font-weight: 600; }\n.ig-search input::placeholder { color: #71899b; }\n\n.ig-conversations { padding: 10px; scrollbar-width: thin; scrollbar-color: #94a9ba transparent; }\n\n.conv-item {\n    gap: 11px;\n    min-height: 58px;\n    margin-bottom: 5px;\n    padding: 10px;\n    border: 1px solid transparent;\n    border-radius: 14px;\n}\n\n.conv-item:hover {\n    border-color: rgba(233, 90, 19, .2);\n    background: #fff8f4;\n    transform: translateX(2px);\n}\n\n.conv-item.active {\n    border-color: rgba(233, 90, 19, .2);\n    background: #fff3ec;\n    box-shadow: inset 3px 0 #e95a13, 0 8px 18px rgba(30, 63, 88, .06);\n}\n\n.avatar {\n    width: 46px;\n    height: 46px;\n    min-width: 46px;\n    border: 2px solid #ffffff;\n    border-radius: 14px;\n    color: #ffffff;\n    background: #4e7799;\n    box-shadow: 0 5px 12px rgba(78, 119, 153, .18);\n    font-size: 1rem;\n}\n\n.avatar img { border-radius: 11px; }\n.avatar.small { width: 38px; height: 38px; min-width: 38px; border-radius: 11px; font-size: .85rem; }\n.conv-info strong { margin-bottom: 4px; color: #29475e; font-family: inherit; font-size: .83rem; font-weight: 800; }\n.last-message { color: #71899b; font-size: .73rem; font-weight: 550; }\n\n.unread-badge {\n    min-width: 19px;\n    height: 19px;\n    padding: 0 5px;\n    border: 2px solid #ffffff;\n    background: #e95a13;\n    box-shadow: 0 3px 8px rgba(233, 90, 19, .22);\n    font-size: .62rem;\n}\n\n.conversation-actions { padding: 6px; color: #71899b; transition: .18s ease; }\n.conversation-actions:hover { color: #e95a13; }\n.conversation-menu-btn { cursor: pointer; }\n.conversation-menu {\n    top: 32px;\n    min-width: 128px;\n    padding: 5px;\n    border: 1px solid rgba(78, 119, 153, .16);\n    border-radius: 11px;\n    background: #fbfcfd;\n    box-shadow: 0 13px 28px rgba(30, 63, 88, .16);\n}\n.conversation-menu button { border-radius: 7px; color: #b63e0a; font-family: inherit; font-size: .73rem; font-weight: 750; }\n.conversation-menu button:hover { background: #fff3ec; }\n\n.ig-chat-panel { background: #f6f9fa; }\n\n.chat-header {\n    height: 74px;\n    padding: 0 22px;\n    border-bottom: 1px solid rgba(78, 119, 153, .15);\n    background: #fbfcfd;\n    box-shadow: 0 5px 16px rgba(30, 63, 88, .04);\n}\n\n.chat-header h3 { color: #1d394f; font-family: inherit; font-size: .95rem; font-weight: 850; letter-spacing: -.01em; }\n.chat-header h3::after { content: \"\"; display: inline-block; width: 6px; height: 6px; margin: 0 0 1px 7px; border-radius: 50%; background: #22a65a; box-shadow: 0 0 0 3px rgba(34, 166, 90, .12); }\n.mobile-back { color: #4e7799; }\n\n.messages {\n    padding: 26px clamp(18px, 4vw, 48px);\n    gap: 9px;\n    background: #f6f9fa;\n    scrollbar-width: thin;\n    scrollbar-color: #94a9ba transparent;\n}\n\n.message {\n    max-width: min(70%, 580px);\n    padding: 11px 14px;\n    border: 1px solid rgba(78, 119, 153, .12);\n    border-radius: 15px;\n    box-shadow: 0 5px 12px rgba(30, 63, 88, .05);\n    font-family: inherit;\n    font-size: .82rem;\n    font-weight: 550;\n}\n\n.message.me { border-color: #e95a13; background: #e95a13; box-shadow: 0 8px 16px rgba(233, 90, 19, .18); border-bottom-right-radius: 4px; }\n.message.them { color: #29475e; background: #ffffff; border-bottom-left-radius: 4px; }\n.message-footer { margin-top: 5px; }\n.message-time, .edited-label { font-size: .63rem; font-weight: 650; }\n.typing-indicator { padding: 9px 12px; border: 1px solid rgba(78, 119, 153, .13); border-radius: 11px; color: #4e7799; background: #ffffff; font-family: inherit; font-size: .72rem; font-weight: 700; }\n.date-separator { width: fit-content; margin: 14px auto; padding: 5px 9px; border: 1px solid rgba(78, 119, 153, .14); border-radius: 999px; color: #71899b; background: #eef3f5; font-family: inherit; font-size: .62rem; letter-spacing: .04em; text-transform: uppercase; }\n\n.chat-input {\n    padding: 14px 18px;\n    border-top: 1px solid rgba(78, 119, 153, .15);\n    background: #fbfcfd;\n}\n\n.chat-textarea {\n    min-height: 44px;\n    padding: 12px 14px;\n    border: 1px solid rgba(78, 119, 153, .18);\n    border-radius: 12px;\n    color: #29475e;\n    background: #f1f5f7;\n    font-family: inherit;\n    font-size: .82rem;\n    font-weight: 550;\n    transition: .18s ease;\n}\n\n.chat-textarea:focus { border-color: #e95a13; background: #ffffff; box-shadow: 0 0 0 4px rgba(233, 90, 19, .1); }\n.chat-input button { width: 44px; height: 44px; border-radius: 12px; background: #e95a13; box-shadow: 0 7px 15px rgba(233, 90, 19, .2); font-size: .9rem; transition: .18s ease; }\n.chat-input button:hover { background: #d84f0d; transform: translateY(-1px); }\n\n.empty-chat-panel, .empty-conversations { color: #71899b; font-family: inherit; }\n.empty-chat-panel .empty-icon, .empty-conversations .empty-icon { display: grid; width: 62px; height: 62px; place-items: center; margin-bottom: 14px; border: 1px solid rgba(233, 90, 19, .2); border-radius: 18px; background: #fff3ec; font-size: 1.75rem; }\n.empty-chat-panel h2, .empty-conversations h3 { color: #29475e; font-family: inherit; font-size: 1rem; font-weight: 850; }\n.empty-chat-panel p, .empty-conversations p { max-width: 290px; margin: 0; font-size: .8rem; font-weight: 550; line-height: 1.55; }\n\n.ig-chat-layout .skeleton, .ig-chat-layout .message-skeleton { background: #e5edf1; animation: conversation-pulse 1.15s ease-in-out infinite alternate; }\n@keyframes conversation-pulse { from { opacity: .55; } to { opacity: 1; } }\n.message-skeleton { border-radius: 14px; }\n\n.ig-chat-layout button:focus-visible, .ig-chat-layout input:focus-visible, .ig-chat-layout textarea:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }\n\n/* Conversation hand-off: selection signal followed by a panel reveal. */\n.conv-item.active { animation: conversation-selected .34s cubic-bezier(.2, .8, .2, 1); }\n\n.chat-open .ig-chat-panel { animation: chat-panel-reveal .42s cubic-bezier(.2, .8, .2, 1) both; }\n\n.chat-open .ig-chat-panel::before {\n    content: \"\";\n    position: absolute;\n    z-index: 20;\n    top: 0;\n    left: 0;\n    width: 3px;\n    height: 100%;\n    transform-origin: top;\n    background: #e95a13;\n    pointer-events: none;\n    animation: chat-signal .52s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.chat-open .chat-header { animation: chat-header-in .38s .08s ease both; }\n.chat-open .messages { animation: chat-content-in .4s .15s ease both; }\n\n@keyframes conversation-selected {\n    0% { transform: translateX(-8px); opacity: .45; }\n    65% { transform: translateX(2px); }\n    100% { transform: translateX(0); opacity: 1; }\n}\n\n@keyframes chat-panel-reveal {\n    from { opacity: 0; transform: translateX(34px) scale(.985); }\n    to { opacity: 1; transform: translateX(0) scale(1); }\n}\n\n@keyframes chat-signal {\n    0% { transform: scaleY(0); opacity: 0; }\n    35% { transform: scaleY(1); opacity: 1; }\n    100% { transform: scaleY(1); opacity: 0; }\n}\n\n@keyframes chat-header-in {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes chat-content-in {\n    from { opacity: 0; transform: translateY(14px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .conv-item.active,\n    .chat-open .ig-chat-panel,\n    .chat-open .ig-chat-panel::before,\n    .chat-open .chat-header,\n    .chat-open .messages { animation: none; }\n}\n\n@media (max-width: 900px) {\n    main:has(.ig-chat-layout) { width: 100%; max-width: 100%; overflow-x: clip; background: #f6f9fa !important; }\n    .ig-chat-layout { box-sizing: border-box; width: 100%; max-width: 100%; height: 100dvh; min-height: 0; margin: 0; border: 0; border-radius: 0; background: #f6f9fa; box-shadow: none; }\n    main .ig-chat-layout { height: calc(100dvh - 124px); }\n    .ig-sidebar { width: 100%; min-width: 100%; border: 0; background: #f6f9fa; }\n    .ig-sidebar-header {  background: #fbfcfd; box-shadow: 0 5px 14px rgba(30, 63, 88, .05); margin-top: 22px; border-radius: 0 0 17px 17px;  }\n    .ig-sidebar-header::before { right: 16px; left: 16px; }\n    .ig-sidebar-header h2 { margin-bottom: 14px; font-size: 1.04rem; }\n    .ig-conversations { padding: 13px 12px 20px; background: #f6f9fa; overscroll-behavior: contain; }\n    .conv-item { min-height: 66px; margin-bottom: 9px; padding: 10px 11px; border-color: rgba(78, 119, 153, .14); border-radius: 16px; background: #ffffff; box-shadow: 0 7px 15px rgba(30, 63, 88, .05); }\n    .conv-item:hover { transform: none; }\n    .conv-item.active { background: #fff8f4; box-shadow: inset 3px 0 #e95a13, 0 8px 18px rgba(30, 63, 88, .07); }\n    .avatar { width: 48px; height: 48px; min-width: 48px; }\n    .conversation-actions { padding: 8px; }\n}\n\n@media (max-width: 768px) {\n    .ig-chat-layout.chat-open { background: #f6f9fa; }\n    .chat-header { height: 68px; padding: 0 14px; gap: 10px; }\n    .mobile-back { display: grid; padding: 10px; width: 20px; height: 20px; place-items: center; border: 1px solid rgba(78, 119, 153, .16); border-radius: 10px; background: #ffffff; font-size: .85rem; }\n    .messages { padding: 18px 13px; }\n    .message { max-width: 84%; padding: 10px 12px; font-size: .79rem; }\n    .chat-input { gap: 9px; padding: 10px 12px calc(10px + env(safe-area-inset-bottom)); }\n    .chat-input button { width: 42px; height: 42px; flex: 0 0 42px; }\n    .chat-textarea { min-height: 42px; padding: 11px 12px; }\n}\n\n/* .date-separator {\n    width: fit-content;\n    margin: 15px auto;\n    background: rgba(255,255,255,.08);\n    padding: 6px 12px;\n    border-radius: 999px;\n    font-size: 12px;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
